import dayjs from "dayjs";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import TaskIcon from "@mui/icons-material/Task";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";

import Modal from "../../myfin_v2/elements/Modal";
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";
import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import StatusIndicator from "../../myfin_v2/elements/StatusIndicator";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { ReactComponent as PlusPrimaryIcon } from "../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as WarningIcon } from "../../myfin_v2/assets/icons/warning.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as Mlogo } from "../../myfin_v2/assets/icons/mLogo.svg";
import DefaultUserRound from "../../myfin_v2/assets/imgs/DefaultUserRound.png";
import { Button, IconButton } from "../../myfin_v2/elements/Button";
import AddColumnsModal from "../../myfin_v2/components/bookclosure/AddColumnsModal";
import { getBookClosureDeleteColumnApiHandler, getBookClosureUpdateColumnApiHandler } from "../Services/ApiHandler";
import { truncateText } from "../../utils/mis";

const BookClosureModuleTasks = ({
  ViewTaskMore,
  addedColumns,
  companyId,
  bookClosureId,
  getBookClosureData,
}) => {
  const history = useHistory();


  const { bookClosureTasks } = useSelector((state) => state.BookClosureReducer);
  const [displayModal, setDisplayModal] = useState(false);
  const [addColumnsModal, setAddColumnsModal] = useState(false);
  const [activeTh, setActiveTh] = useState(null); // ID of clicked column
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const thRefs = useRef({}); // refs for each <th>
  const hoverTimeout = useRef(null);
  const [columnUpdateModal, setColumnUpdateModal] = useState(false);
  const [activeColumnTitle, setActiveColumnTitle] = useState("");
  const [columnOption, setColumnOption] = useState(false);

  const handleClose = () => {
    setDisplayModal(false);
  };

  const handleClick = (columnId, columnTitle) => {
    const rect = thRefs.current[columnId].getBoundingClientRect();
    setPopupPosition({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    });
    setActiveTh(columnId);
    setColumnOption(true)
    setActiveColumnTitle(columnTitle)
  };

  const handleMouseLeave = () => {
    hoverTimeout.current = setTimeout(() => {
      if(!columnUpdateModal){
        setActiveTh(null);
        setActiveColumnTitle("")
      }
    }, 200);
  };

  const handlePopupEnter = () => {
    clearTimeout(hoverTimeout.current);
  };

  const deleteColumn = (columnId) => {
    const payload = {
      bookClosureID: bookClosureId,
      companyID: companyId,
      columnID: columnId,
    };

    getBookClosureDeleteColumnApiHandler(payload)
      .then((response) => {
        getBookClosureData(companyId);
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to delete column",
          "error"
        );
      });
  };

  const handleColumnUpdate = () => {
    const payload = {
      bookClosureID: bookClosureId,
      companyID: companyId,
      columnID: activeTh,
      columnTitle: activeColumnTitle
    }

    getBookClosureUpdateColumnApiHandler(payload)
      .then((response)=> {
        getBookClosureData(companyId);
        setColumnUpdateModal(false);
        setActiveColumnTitle("");
        
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to delete column",
          "error"
        );
      });
  }

  return (
    <>
      <div className={bookclosuretablecss.bookClosureTableContainerV2}>
        <table className={bookclosuretablecss.bookClosureTable}>
          <thead>
            <th className="text-left" style={{ width: "375px" }}>
              Task / Template Name
            </th>
            <th style={{ width: "200px" }}>Module</th>
            <th className="text-left" style={{ width: "200px" }}> Assignee</th>
            <th className="text-left" style={{ width: "150px" }}>Approver</th>
            <th className="text-left" style={{ width: "130px" }}>Due Date</th>
            <th className="text-left" style={{ width: "120px" }}>Status</th>
            {addedColumns &&
              addedColumns.length > 0 &&
              addedColumns
              // .filter(
              //   (col) => col.columnType !== "longText" && col.columnType !== "shortText"
              // )
              .map((addedColumn, index) => (
                <React.Fragment key={index}>
                  <th
                    className="text-left"
                    key={addedColumn.columnID}
                    ref={(el) => (thRefs.current[addedColumn.columnID] = el)}
                    onClick={() => handleClick(addedColumn.columnID,addedColumn.columnTitle)}
                    onMouseLeave={handleMouseLeave}
                    style={{
                      cursor: "pointer",
                      width:
                        addedColumn.columnType === "longText"
                          ? "300px"
                          : addedColumn.columnType === "shortText"
                          ? "300px"
                          : "200px",
                    }}
                  >
                    {addedColumn.columnTitle}
                  </th>
                </React.Fragment>
            ))}
            {addedColumns &&
              // addedColumns.length < 2 && 
              (

              <th style={{ width: "140px", padding: "0px",textAlign: "right" }}>
                <button
                  className={`${buttoncss.custom_btn} ${buttoncss.secondary} ${buttoncss.buttonIcon}  `}
                  style={{ width: "fit-content" }}
                  onClick={() => {
                    if (addedColumns.length >= 2) {
                      swal("Info", "Maximum of 2 columns can be added", "info");
                      return;
                    }
                    setDisplayModal(true);
                    setAddColumnsModal(true);
                  }}
                >
                  <span className={buttoncss.addIconSpan}>
                    {<PlusPrimaryIcon width={15} height={15} />}
                  </span>
                  {/* <span className={commoncss.labelAddclm}>Add Column</span> */}
                </button>
              </th>
              )}
          </thead>
          <tbody>
            {bookClosureTasks && bookClosureTasks.length > 0 ? (
              bookClosureTasks
              .filter(task => task.deleted !== true) 
              .map((task, index) => (
                <React.Fragment key={index}>
                  <tr
                    key={index}
                    onClick={() => ViewTaskMore(task._id)}
                  >
                    <td style={{ 
                      color: task?.libraryTaskID ? "#277154" : "#111111",
                      width: "400px" 
                      }}>
                      {task?.libraryTaskID && task?.template? <span> <Mlogo height={16} style={{ marginRight:"7px" }}/> {truncateText(task?.name, 5550)}</span>: truncateText(task?.name, 5550)}
                    </td>
                    <td
                      style={{
                        "text-transform": "uppercase",
                        "font-weight": "600",
                      }}
                    >
                      {task?.module}
                    </td>
                    <td>
                      <div className={bookclosuretablecss.bkclColumnWithImgCtn}>
                          <div className="d-flex mb-1">
                            {task.assigneeData.slice(0,2).map((assign, idx) => (
                              <img
                                key={idx}
                                src={assign.profileImageUrl || DefaultUserRound}
                                className={bookclosuretablecss.bkclUserImg}
                                style={{
                                  marginLeft: idx === 0 ? "0px" : "-8px"
                                }}
                              />
                            ))}
                              {task.assigneeData.length > 2 && (
                                <div className={bookclosuretablecss.bkclImgCountCtn}>
                                  {task.assigneeData.length - 2}+
                                </div>
                              )}
                          </div>
                          <div className={bookclosuretablecss.userNameTruncate}>
                            {task.assigneeData.map(assign => assign.name).join(", ")}
                          </div>
                        </div>
                    </td>
                    <td>
                      <div className={bookclosuretablecss.bkclColumnWithImgCtn} style={{ gap:"0px" }}>

                        {task.approverData && (
                          <>
                            <img
                              src={task.approverData.profileImageUrl || DefaultUserRound}
                              className={bookclosuretablecss.bkclUserImg}
                              alt={task.approverData.name}
                            />
                            <span style={{ marginLeft: "6px" }}>{task.approverData.name}</span>
                          </>
                        )}
                      </div>
                    </td>
                    <td>
                      {task?.dueDate
                        ? dayjs(task?.dueDate).format("DD-MMM-YYYY")
                        : ""}
                    </td>
                    <td>
                      {" "}
                      <div className="d-flex">
                        <StatusIndicator status={task.status} />
                        {task.status === "approved" && (
                          <>
                            {(task.hasOpenAndNotReviewedLinkedTasks ||
                              task.hasApprovedAndNotReviewedLinkedTasks) && (
                              <div
                                className={`${commoncss.tooltipWrapper} ml-1`}
                              >
                                <WarningIcon className={commoncss.vaTop} />
                                <div className={commoncss.tooltip}>
                                  {task.hasOpenAndNotReviewedLinkedTasks &&
                                    task.hasApprovedAndNotReviewedLinkedTasks && (
                                      <>
                                        There have been changes to the connected
                                        tasks. Please review and make changes if
                                        required.
                                      </>
                                    )}
                                  {task.hasOpenAndNotReviewedLinkedTasks &&
                                    !task.hasApprovedAndNotReviewedLinkedTasks && (
                                      <>
                                        This task has new connected tasks that
                                        may impact work performed. Please review
                                        and make changes if required.
                                      </>
                                    )}
                                  {!task.hasOpenAndNotReviewedLinkedTasks &&
                                    task.hasApprovedAndNotReviewedLinkedTasks && (
                                      <>
                                        Connected tasks have been approved.
                                        Please review and make changes if
                                        required.
                                      </>
                                    )}
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </td>
                    {/* {task.columns &&
                      task.columns.length > 0 &&
                      task.columns.map((tc, index) => {
                        const matchedColumn = addedColumns.find(
                          (col) => col.columnID === tc.columnId
                        );

                        // if (!matchedColumn || matchedColumn.columnType === "longText" || matchedColumn.columnType === "shortText") {
                        //   return null;
                        // }

                        return (
                          <React.Fragment key={index}>
                            <td className="text-left" key={tc.columnId}>
                              {matchedColumn?.columnType === "date"
                                ? dayjs(tc?.columnValue).isValid()
                                  ? dayjs(tc.columnValue).format("DD-MMM-YYYY")
                                  : tc?.columnValue
                                : tc?.columnValue}
                            </td>
                          </React.Fragment>
                        );
                      })} */}

                    {addedColumns.map((addedColumn) => {
                      const tc = task.columns.find(c => c.columnId === addedColumn.columnID);
                      let displayValue = tc?.columnValue || "";
                      if (addedColumn.columnType === "date" && displayValue) {
                        const parsedDate = dayjs(displayValue, ["YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY"]);
                        displayValue = parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : displayValue;
                      }

                      if (addedColumn.columnType === "people" && tc?.usersData?.length) {
                        return (
                          <td key={addedColumn.columnID} className="text-left">
                            <div className={bookclosuretablecss.bkclColumnWithImgCtn}>
                              <div className="d-flex mb-1">
                                {tc.usersData.slice(0, 2).map((user, idx) => (
                                  <img
                                    key={idx}
                                    src={user.profileImageUrl || DefaultUserRound}
                                    className={bookclosuretablecss.bkclUserImg}
                                    style={{ marginLeft: idx === 0 ? "0px" : "-8px" }}
                                  />
                                ))}
                                {tc.usersData.length > 2 && (
                                  <div className={bookclosuretablecss.bkclImgCountCtn}>
                                    {tc.usersData.length - 2}+
                                  </div>
                                )}
                              </div>
                              <div className={bookclosuretablecss.userNameTruncate}>
                                {tc.usersData.map(user => user.name).join(", ")}
                              </div>
                            </div>
                          </td>
                        );
                      }

                      if (addedColumn.columnType === "tag" && Array.isArray(tc?.columnValue)) {
                        return (
                          <td key={addedColumn.columnID} className="text-left">
                            {tc.columnValue.join(", ")}
                          </td>
                        );
                      }

                      if (addedColumn.columnType === "longText" && displayValue) {
                        return (
                          <td key={addedColumn.columnID} className="text-left">
                            {truncateText(displayValue, 35)}
                          </td>
                        );
                      }
                      
                      if (addedColumn.columnType === "shortText" && displayValue) {
                        return (
                          <td key={addedColumn.columnID} className="text-left">
                            {truncateText(displayValue, 35)}
                          </td>
                        );
                      }

                      return (
                        <td key={addedColumn.columnID} className="text-left">
                          {displayValue}
                        </td>
                      );
                    })}
                  </tr>
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td
                  colSpan={6}
                  className="text-secondary text-center font-size-16 custom-font-600 font-inter"
                >
                  {" "}
                  Once you add tasks, you'll see them here.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {activeTh && columnOption && (
          <div
            className={commoncss.itemMenuContainer}
            onMouseEnter={handlePopupEnter}
            onMouseLeave={handleMouseLeave}
            style={{
              top: popupPosition.top,
              left: popupPosition.left,
            }}
          >
            <div
              style={{ cursor:"pointer" }}
              className={` ${commoncss.itemMenu}`}
              onClick={()=>{
                setColumnUpdateModal(true);
                setDisplayModal(true);
                setColumnOption(false);
              }}
              >Edit Column</div>
            <div
              className={`${commoncss.clickable}  ${commoncss.itemMenu}`}
              onClick={() => {
                deleteColumn(activeTh);
              }}
            >
              Delete Column
            </div>
          </div>
        )}
      </div>
      {displayModal && addColumnsModal && (
        <AddColumnsModal
          handleClose={handleClose}
          setAddColumnsModal={setAddColumnsModal}
          companyId={companyId}
          bookClosureId={bookClosureId}
          getBookClosureData={getBookClosureData}
        />
      )}
      {activeTh && columnUpdateModal && displayModal && (
        <Modal
          title="Edit column"
          bodycss={commoncss.unsetPadding}
          headerActions={
            <CloseIcon
            onClick={() => {
              setDisplayModal(false);
              setColumnUpdateModal(false);
            }}
            className="clickable"
            />
          }
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={() => {setColumnUpdateModal(false)}}
                label="Cancel"
              />
              <Button
                btnColor={buttoncss.primary}
                label="Update"
                onClick={(e) => {
                  handleColumnUpdate(e);
                }}
              />
            </>
          }
          >
          <div className={commoncss.pd1530}>
            <InputGroup
              label="Column name"
              req={true}
              inputs={[
              <>
                <input
                  type="text"
                  value={activeColumnTitle}
                   onChange={(e) => setActiveColumnTitle(e.target.value)}
                />
              </>,
              ]}
            />
            </div>
          </Modal>
        )}
    </>
  );
};

export default BookClosureModuleTasks;
